import { createRouter, createWebHistory } from 'vue-router';

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "home" */ '@/pages/Home'),
    },
    {
      path: '/ticket-history',
      name: 'TerminalTicketHistory',
      component: () => import(/* webpackChunkName: "TerminalHistory" */ '@/layouts/TerminalHistory'),
    },
    {
      path: '/results',
      name: 'TerminalResults',
      component: () => import(/* webpackChunkName: "TerminalResults" */ '@/layouts/TerminalResults'),
    },
    {
      path: '/ticket-details',
      name: 'TerminalTicketDetails',
      component: () => import(/* webpackChunkName: "TerminalTicketDetails" */ '@/layouts/TerminalTicketDetails'),
    },
  ],
});
